import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';

import { ClaimDocumentsPartialState } from './claim-documents.reducer';
import { ClaimDocument, ClaimDocumentForm } from './claim-documents.models';
import {
  LoadClaimOwnerDocuments,
  LoadClaimOwnerDocumentsSuccess,
  LoadClaimOwnerDocumentsFail,
  ClaimDocumentsActionTypes,
  SaveClaimDocumentInformation,
  SaveUpload,
  SaveUploadFail,
  UpdateUpload,
  UpdateUploadFail,
  SaveUploadSuccess,
  UpdateUploadSuccess,
  UpdateClaimDocumentInformation
} from './claim-documents.actions';
import { ClaimDocumentsService } from '../claim-documents.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClaimDocumentsEffects {
  @Effect() getOwnerClaimDocuments$ = this.dataPersistence.fetch(
    ClaimDocumentsActionTypes.LOAD_CLAIM_OWNER_DOCUMENTS,
    {
      run: (
        action: LoadClaimOwnerDocuments,
        state: ClaimDocumentsPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .getDocumentsByOwner(action.payload)
          .pipe(
            map(
              (documents: ClaimDocument[]) =>
                new LoadClaimOwnerDocumentsSuccess(documents)
            )
          );
      },

      onError: (action: LoadClaimOwnerDocuments, error) => {
        
        return new LoadClaimOwnerDocumentsFail(error);
      }
    }
  );

  @Effect()
  saveDocument$ = this.dataPersistence.fetch(
    ClaimDocumentsActionTypes.SAVE_CLAIM_DOCUMENT_INFORMATION,
    {
      run: (
        action: SaveClaimDocumentInformation,
        state: ClaimDocumentsPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .saveDocumentInformation(action.payload)
          .pipe(map((document: ClaimDocumentForm) => new SaveUpload(document)));
      },

      onError: (action: SaveClaimDocumentInformation, error) => {
        
        return new SaveUploadFail(error);
      }
    }
  );

  @Effect()
  updateDocument$ = this.dataPersistence.fetch(
    ClaimDocumentsActionTypes.UPDATE_CLAIM_DOCUMENT_INFORMATION,
    {
      run: (
        action: UpdateClaimDocumentInformation,
        state: ClaimDocumentsPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .updateDocumentInformation(action.payload)
          .pipe(
            map((document: ClaimDocumentForm) => new UpdateUpload(document))
          );
      },

      onError: (action: UpdateClaimDocumentInformation, error) => {
        
        return new UpdateUploadFail(error);
      }
    }
  );

  @Effect()
  upload$ = this.dataPersistence.fetch(ClaimDocumentsActionTypes.SAVE_UPLOAD, {
    run: (action: SaveUpload, state: ClaimDocumentsPartialState) => {
      // Your custom REST 'load' logic goes here. For now just return an empty list...
      return this.service
        .upload(action.payload)
        .pipe(
          map((document: ClaimDocument) => new SaveUploadSuccess(document))
        );
    },

    onError: (action: SaveUpload, error) => {
      
      return new SaveUploadFail(error);
    }
  });

  @Effect()
  editUpload$ = this.dataPersistence.fetch(
    ClaimDocumentsActionTypes.UPDATE_UPLOAD,
    {
      run: (action: UpdateUpload, state: ClaimDocumentsPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .upload(action.payload)
          .pipe(
            map((document: ClaimDocument) => new UpdateUploadSuccess(document))
          );
      },

      onError: (action: UpdateUpload, error) => {
        
        return new UpdateUploadFail(error);
      }
    }
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<ClaimDocumentsPartialState>,
    private service: ClaimDocumentsService
  ) {}
}
